const floatingIcon = document.createElement('div');
floatingIcon.id = 'floating-icon';
floatingIcon.style.position = 'absolute';
floatingIcon.style.top = '75px';
floatingIcon.style.right = '155px';
floatingIcon.style.zIndex = '9999';
floatingIcon.style.cursor = 'pointer';

// Create a span element to hold the zipcode
const zipcodeSpan = document.createElement('span');
zipcodeSpan.id = 'zipcode-span';
zipcodeSpan.style.marginRight = '5px';  // Space between zipcode and icon
zipcodeSpan.style.fontSize = '13px';
zipcodeSpan.style.color = '#000';

// Add the SVG icon as the innerHTML
floatingIcon.innerHTML = `
<img style="width:32px;height:auto;" src="https://cdn.shopify.com/s/files/1/0706/0655/3265/files/istockphoto-1190338480-612x612.jpg?v=1750675044">
    <!--svg id="icon_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.64 69.67" style="height: 40px; width: 40px;background: #000;padding: 8px;">
        <defs><style>.cls-1{fill:#fff;}</style></defs>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path class="cls-1" d="M78.25,43.71a1.85,1.85,0,0,0-1.64-1.09H48.75C53.12,33.88,58,22.4,58,16.94a16.67,16.67,0,1,0-33.34,0c0,5.46,5.19,16.94,9.29,25.68H11.59A1.85,1.85,0,0,0,10,43.71L.11,67.21a1.8,1.8,0,0,0,.28,1.64A1.64,1.64,0,0,0,2,69.67H86.72a2.33,2.33,0,0,0,1.64-.82,3.39,3.39,0,0,0,.28-1.64ZM41.37,3.82A13.3,13.3,0,0,1,54.48,16.94c0,4.64-5.19,16.39-9.83,25.68a67.06,67.06,0,0,1-3.28,6.29c-4.65-9-13.12-26-13.12-32A13.3,13.3,0,0,1,41.37,3.82Zm-1.64,50a1.64,1.64,0,0,0,1.64.82A1.94,1.94,0,0,0,43,53.82a64.47,64.47,0,0,0,3.82-7.37H75.25l1.64,4.1-37.16,9L17.87,46.45h18c2.19,4.1,3.83,7.1,3.83,7.37ZM12.41,47l13.11,7.93L7.22,59.56ZM5.58,63.93l24.59-6.28L44.1,66.12H4.48ZM51.2,66.12,44.37,62l34.15-8.47,5.2,12.57Z" style="fill: rgb(255, 255, 255);"></path>
                <path class="cls-1" d="M49.29,17.49a7.92,7.92,0,1,0-7.92,7.92A7.93,7.93,0,0,0,49.29,17.49Zm-7.92,4.09A4.31,4.31,0,0,1,37,17.21a4.27,4.27,0,0,1,4.37-4.1,4.32,4.32,0,0,1,4.37,4.38A4.26,4.26,0,0,1,41.37,21.58Z" style="fill: rgb(255, 255, 255);"></path>
            </g>
        </g>
    </svg-->
`;

// Append the zipcodeSpan before the svg inside floatingIcon
floatingIcon.insertBefore(zipcodeSpan, floatingIcon.firstChild);

document.body.appendChild(floatingIcon);

// Create the modal HTML structure
const popupModal = document.createElement('div');
popupModal.id = 'popup-modal';
popupModal.style.display = 'none';  
popupModal.style.position = 'fixed';
popupModal.style.top = '0';
popupModal.style.left = '0';
popupModal.style.width = '100%';
popupModal.style.height = '100%';
popupModal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
popupModal.style.zIndex = '9999';
popupModal.style.justifyContent = 'center';
popupModal.style.alignItems = 'center';

popupModal.innerHTML = `
      <div style="background-color: #fff; padding: 30px 20px; max-width: 400px; margin: auto; border-radius: 10px; position: relative;">
            <button id="close-modal" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 20px; color: #000;">&times;</button>
            <h2>Check availability</h2>
            <p>Enter your zip code to check delivery availability in your area.</p>
            <div class="cart-zipcode">
                <input oninput="this.value = this.value.replace(/[^0-9]/g, '');"  type="text" id="cart-zipcode" name="cart_zipcode" required placeholder="Enter your zipcode" maxlength="6" style="width: 100%; padding: 8px; font-size: 16px; border: 1px solid #ccc; border-radius: 5px;" />
                <p id="zipcode-error" style="color: red; font-size: 14px; margin-top: 5px; display: none;">Please enter a valid 6-digit Zip Code.</p>
                <button type="button" id="check-zipcode" style="margin-top: 10px; padding: 10px; background-color: #28a745; color: white; border: none; cursor: pointer;">Save Location</button>
                <button type="button" id="set-zipcode" style="margin-top: 10px; padding: 10px; background-color: #b76f6e; color: white; border: none; cursor: pointer;">Current Location</button>
            </div>
        </div>
`;

document.body.appendChild(popupModal);

// Get modal and button elements
const closeModal = document.getElementById('close-modal');
const checkZipcodeButton = document.getElementById('check-zipcode');
const zipcodeInput = document.getElementById('cart-zipcode');
const zipcodeMessage = document.getElementById('zipcode-message');

// Show modal when floating icon is clicked
floatingIcon.addEventListener('click', () => {
    popupModal.style.display = 'flex';  // Display the modal
});

// Close modal when close button is clicked
closeModal.addEventListener('click', () => {
    popupModal.style.display = 'none';  // Hide the modal

    // Do not overwrite user_postalCode
    const storedPostalCode = localStorage.getItem('user_postalCode');

    if (storedPostalCode) {
        document.getElementById('cart-zipcode').value = storedPostalCode;
        document.getElementById('zipcode-span').textContent = `Deliver to: ${storedPostalCode}`;
    }

    zipcodeError.style.display = 'none'; // Hide error message
    zipcodeInput.style.border = "1px solid #ccc"; // Reset input border
});

// Save and validate zipcode
checkZipcodeButton.addEventListener('click', () => {
    const zipcode = zipcodeInput.value.trim();
      // console.log("djkhskd",zipcode);
    if (!zipcode || zipcode.length < 6) {
         // console.log("inside if",zipcode);
        zipcodeMessage.textContent = "Please enter a valid zipcode.";
        zipcodeMessage.style.display = 'block';
        zipcodeMessage.style.color = 'red';
        return;
    }
localStorage.removeItem('zipcode_data');

    // Save the zipcode to localStorage
    // localStorage.setItem('zipcode_data', JSON.stringify({ zipcode }));

    // Update the floating icon with the zipcode
    zipcodeSpan.textContent = `Deliver to: ${zipcode}`;

    // Close the modal
    popupModal.style.display = 'none';

    // Reload the page to reflect the changes
    // location.reload();
});

// // Populate input field with stored zipcode when the page loads
document.addEventListener('DOMContentLoaded', () => {
    const storedPostalCode = localStorage.getItem('user_postalCode');

    if (storedPostalCode) {
        document.getElementById('cart-zipcode').value = storedPostalCode;
        document.getElementById('zipcode-span').textContent = `Deliver to: ${storedPostalCode}`; // Set the displayed postal code
    }
});


const cartItems = document.querySelectorAll('.cart-drawer .cart-items .cart-item__quantity input');

// Loop through each cart item and get the value of data-quantity-variant-id
const variantIds = [];
cartItems.forEach(item => {
    const variantId = item.getAttribute('data-quantity-variant-id');
    if (variantId) {
        variantIds.push(variantId);
    }
});
console.log("Collected Variant IDs:", variantIds);

// Function to remove product from cart
function removeProductFromCart(variantId) {
  console.log("remove item zipcode change 1");
    console.log("Attempting to remove product with Variant ID:", variantId);

    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            console.log("Cart Data:", cart);
            const lineItem = cart.items.find(item => item.variant_id == variantId);
            
            if (lineItem) {
                console.log("Line Item Found:", lineItem);

                fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ id: lineItem.id, quantity: 0 })
                })
                .then(response => response.json())
                .then(updatedCart => {
                    console.log("Product removed from cart. Updated Cart:", updatedCart);
                })
                .catch(error => {
                    console.error("Error removing product from cart:", error);
                });
            } else {
                console.warn("Line Item not found for Variant ID:", variantId);
            }
        })
        .catch(error => {
            console.error("Error fetching cart:", error);
        });
}

// Event listener for "Save Location" button
checkZipcodeButton.addEventListener('click', () => {
    const zipcode = zipcodeInput.value.trim();
    console.log("Entered Zipcode:", zipcode);

    if (!zipcode || zipcode.length < 6) {
        zipcodeMessage.textContent = "Please enter a valid zipcode.";
        zipcodeMessage.style.display = 'block';
        zipcodeMessage.style.color = 'red';
        console.warn("Invalid Zipcode entered.");
        return;
    }
localStorage.removeItem('zipcode_data');

    // Save the zipcode to localStorage
    // localStorage.setItem('zipcode_data', JSON.stringify({ zipcode }));
    // console.log("Saved Zipcode to LocalStorage:", zipcode);

    // Update floating icon
    zipcodeSpan.textContent = `Deliver to: ${zipcode}`;

    // Close modal and reload page
    popupModal.style.display = 'none';
    console.log("Reloading page...");
    location.reload();
});

// Check deliverability status
variantIds.forEach(variantId => {
  const alternateId_cart = document.querySelector("td.cart-item__details input[name='alternate_id']").value;
  const localstorageZipcode = localStorage.getItem("user_postalCode");
  const zipcode = localstorageZipcode || "";
    const requestBody = {
        store_url: Shopify.shop,
        alternate_id: alternateId_cart,
        area_code: zipcode,
        latitude: localStorage.getItem("user_latitude"),
        longitude: localStorage.getItem("user_longitude"),
    };

    console.log("Sending Deliverability Check Request:", requestBody);

    fetch("https://live.eazehub.com/live/strsvc/shopify/product-deliverability-status", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
    })
    .then(response => response.json())
    .then(data => {
        console.log("Deliverability Check Response:", data);

        if (data.message && data.message.data && data.message.data.deliverable) {
            const deliverableStatus = data.message.data.deliverable;
            console.log(`Deliverability Status for Variant ID ${variantId}:`, deliverableStatus);

            if (deliverableStatus === "No") {
                console.log(`Removing non-deliverable product with Variant ID: ${variantId}`);
                removeProductFromCart(variantId);
                setTimeout(() => {
                  console.log("remove item zipcode change 2");
                    console.log("Reloading page after removing product...");
                    location.reload();
                }, 1000);
            }
        } else {
            console.warn(`Deliverability status missing in response for Variant ID ${variantId}`);
        }
    })
    .catch(error => {
        console.error("Error checking deliverability:", error);
    });
});


// Add custom styles
const styles = document.createElement('style');
styles.textContent = `
  button#check-zipcode {
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
    word-break: break-all;
    opacity: 1;
    cursor: pointer;
    width: 49%;
    min-height: 40px;
    border-radius: 6px;
    padding: 0 6px;
    margin-top: 0;
    font-size: 14px;
    line-height: normal;
  }
  button#set-zipcode {
    width: 50%;
}
  div#floating-icon {
    background: #fff;
    border-radius: 10px;
    align-items: center;
    display: flex;
    padding: 0px 10px;
}
  input#cart-zipcode {
    width: 55%;
    padding: 0 10px;
    min-height: 40px !important;
    border-radius: 6px;
  }
  .product-form .form {
display: flex;
align-items: center;
justify-content: center;
flex-direction: column-reverse;
flex-wrap: wrap;
gap: 1rem;
}
.product-form__buttons {
width: 100% !important;
max-width: 100% !important;
min-width: 100% !important;
margin-top: 0rem !important;
gap: 1rem;
}
.shopify-payment-button,
.product-form__submit.button {
width: 100% !important;
max-width: 100% !important;
min-width: 100% !important;
}
.product-form__buttons {
display: flex;
align-items: center;
justify-content: center;
flex-wrap: wrap;
}
.product-form #zipcode-message {
width: 100%;
max-width: 100%;
min-width: 100%;
margin-bottom: 1rem;
}
button#set-zipcode {
    border-radius: 6px;
    min-height: 40px;
}
`;
document.head.appendChild(styles);


//Add duplicate add to cart button
document.querySelectorAll('product-form form').forEach(form => {
  form.innerHTML += `
    <button
      type="submit"
      name="duplicate"
      class="quick-add__submit button button--full-width button--secondary duplicate-custom"
      aria-haspopup="dialog"
      aria-labelledby="Add to cart"
      aria-live="polite"
      data-sold-out-message="true"
      style="display: block;"
    >
      <span>Add to cart</span>
    </button>
    <div id="zipcode-message" style="display: none; margin-top: 8px; font-size: 14px; color: green;"></div>
  `;
});


const productFormsbtss = document.querySelectorAll('product-form');

// Loop through each <product-form>
productFormsbtss.forEach((productForm) => {
  // Find the button inside each <product-form>
  const button = productForm.querySelector('button');
  
  // Check if the button exists
  if (button) {
    // Add "display: none;" style to the button
    button.style.display = 'none';
  }
});

//collection card validator

document.addEventListener('DOMContentLoaded', function () {
    const postalCodeInput = document.getElementById('cart-zipcode');
    let latitude = null;
    let longitude = null;

    // Check if a postal code is saved in localStorage
    const savedPostalCode = localStorage.getItem('user_postalCode');

    if (postalCodeInput && savedPostalCode) {
        postalCodeInput.value = savedPostalCode;
    } else {
        if (navigator.geolocation) {
            console.log('Geolocation is supported');

            navigator.geolocation.getCurrentPosition(
                async function (position) {
                    latitude = position.coords.latitude;
                    longitude = position.coords.longitude;

                    console.log('Latitude:', latitude);
                    console.log('Longitude:', longitude);

                    // Reverse Geocoding using Google Maps Geocoding API
                    const apiKey = 'AIzaSyBRJcUmvzO1o9xd4h6Vw2u0In6HBHPOBd0'; // Replace with your actual API key
                    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

                    try {
                        const response = await fetch(url);
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        const data = await response.json();
                        console.log('Geocoding API Response:', data);

                        if (data.status === "OK") {
                            const addressComponents = data.results[0].address_components;
                            let postalCode = '';

                            addressComponents.forEach(component => {
                                if (component.types.includes('postal_code')) {
                                    postalCode = component.long_name;
                                }
                            });

                            console.log(`Postal Code: ${postalCode}`);

                            if (postalCodeInput && !postalCodeInput.value) {
                                postalCodeInput.value = postalCode;
                            }

                            // Store postal code and coordinates
                            localStorage.setItem('user_postalCode', postalCode);
                            localStorage.setItem('user_latitude', latitude);
                            localStorage.setItem('user_longitude', longitude);

                            const checkZipcodeButton = document.getElementById('check-zipcode');
                            if (checkZipcodeButton) {
                                checkZipcodeButton.click();
                            }
                        } else {
                            console.error("Geocoding API Error:", data.status, data.error_message);
                        }
                    } catch (error) {
                        console.error("Error fetching address:", error.message);
                    }
                },
                function (error) {
                    console.error("Geolocation error:", error.message);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }

    // Set lat/lon to 0 when the user changes the postal code manually
    if (postalCodeInput) {
        postalCodeInput.addEventListener('input', function () {
            localStorage.setItem('user_postalCode', postalCodeInput.value);
            localStorage.setItem('user_latitude', "");
            localStorage.setItem('user_longitude', "");
        });
    }
});
const currentLocationButton = document.getElementById('set-zipcode');

currentLocationButton.addEventListener('click', () => {
    if (navigator.geolocation) {
        console.log('Fetching current location...');

        navigator.geolocation.getCurrentPosition(
            async function (position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                console.log('Fetched Latitude:', latitude);
                console.log('Fetched Longitude:', longitude);

                // Reverse Geocoding to get ZIP code
                const apiKey = 'AIzaSyBRJcUmvzO1o9xd4h6Vw2u0In6HBHPOBd0'; // Replace with your actual API key
                const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    console.log('Geocoding API Response:', data);

                    if (data.status === "OK") {
                        let postalCode = '';
                        data.results[0].address_components.forEach(component => {
                            if (component.types.includes('postal_code')) {
                                postalCode = component.long_name;
                            }
                        });

                        if (postalCode) {
                            console.log(`Fetched Postal Code: ${postalCode}`);

                            // Store location data in localStorage
                            localStorage.setItem('user_postalCode', postalCode);
                            localStorage.setItem('user_latitude', latitude);
                            localStorage.setItem('user_longitude', longitude);

                            // Update UI elements
                            document.getElementById('cart-zipcode').value = postalCode;
                            document.getElementById('zipcode-span').textContent = `Deliver to: ${postalCode}`;
                        } else {
                            console.error("Postal code not found in response.");
                        }
                    } else {
                        console.error("Geocoding API Error:", data.status, data.error_message);
                    }
                } catch (error) {
                    console.error("Error fetching ZIP from GPS:", error.message);
                }

                // Close the modal
                popupModal.style.display = 'none';
            },
            function (error) {
                console.error("Geolocation error:", error.message);
            }
        );
    } else {
        console.error("Geolocation is not supported by this browser.");
    }
});

document.addEventListener("DOMContentLoaded", () => {
  let currentMessageElement = null;
  document.querySelectorAll("button[name='duplicate']").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const productForm = button.closest("form");
      const variantId = productForm.querySelector("input[name='id']").value;
      const alternate_id = productForm.querySelector("input[name='alternate_id']").value;
      const localstorageZipcode = localStorage.getItem("user_postalCode");
      const zipcode = localstorageZipcode || "";
      const latitude = localStorage.getItem("user_latitude");
      const longitude = localStorage.getItem("user_longitude");
      const messageElement = productForm.querySelector("#zipcode-message");

      if (currentMessageElement && currentMessageElement !== messageElement) {
        currentMessageElement.textContent = "";
        currentMessageElement.style.display = "none";
      }
      currentMessageElement = messageElement;

      messageElement.textContent = "";
      messageElement.style.display = "none";

      if (!zipcode) {
        messageElement.textContent = "Please enter a ZIP code.";
        messageElement.style.color = "red";
        messageElement.style.fontSize = "14px";
        messageElement.style.display = "block";
        return;
      }

      let isOndcProduct = productForm?.getAttribute("data-is-ondc");
      console.log("isondc: ", isOndcProduct);
      if (!isOndcProduct) {
        const hiddenInput = document.getElementById('isOndcProduct')?.value;
        if (hiddenInput) {
          isOndcProduct = hiddenInput;
        }
      }

      if (isOndcProduct === 'true') {
        const requestBody = {
          store_url: Shopify.shop,
          alternate_id: alternate_id,
          area_code: zipcode,
          latitude: latitude,
          longitude: longitude,
        };

        console.log("Request Body:", requestBody);

        fetch("https://live.eazehub.com/live/strsvc/shopify/product-deliverability-status", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("API Response:", data);
            const deliverableStatus = data.message.data.deliverable;
            const addToCartButton = productForm.querySelector("button[name='add']");
            
            let message = "";

            if (deliverableStatus === "Yes") {
              message = "Delivery is available to this ZIP code!";
              messageElement.style.color = "green";
              messageElement.style.display = "block";

              if (addToCartButton) {
                addToCartButton.disabled = false;
                const event = new CustomEvent('buttonStatusCheck', { detail: { disabled: addToCartButton.disabled } });
                document.dispatchEvent(event);
                addToCartButton.style.display = "block";
                button.style.display = "none";
                addToCartButton.click();
              }
            } else {
              message = "Sorry, delivery is not available to this ZIP code.";
              messageElement.style.color = "red";
              messageElement.style.display = "block";

              if (addToCartButton) {
                addToCartButton.disabled = true;
                const event = new CustomEvent('buttonStatusCheck', { detail: { disabled: addToCartButton.disabled } });
                document.dispatchEvent(event);
                addToCartButton.style.pointerEvents = "none";
              }

              // Fetch the cart to get the line item ID for removal
              try {
                const cartResponse = await fetch("/cart.js");
                const cartData = await cartResponse.json();
                console.log("Cart Data:", cartData);

                const lineItem = cartData.items.find(item => item.variant_id == variantId);
                if (lineItem) {
                  await removeProductFromCart(lineItem.id);
                  setTimeout(() => {
                    console.log("remove item zipcode change 3");
                            location.reload();
                        }, 1000);
                } else {
                  console.log("Product not found in cart.");
                }
              } catch (error) {
                console.error("Error fetching cart data:", error);
              }
            }

            messageElement.textContent = message;
          })
          .catch((error) => {
            console.error("Error:", error);
            alert("An error occurred. Please try again.");
          });
      } else {
        console.log('Product is not ONDC, skipping ZIP code check.');
      }
    });
  });

  document.querySelectorAll("button[name='add']").forEach((button) => {
    button.addEventListener("click", (event) => {
      if (button.disabled) {
        event.preventDefault();
        console.log("Add to Cart is disabled. Action prevented.");
      }
    });
  });

  const checkZipcodeButton = document.getElementById("check-zipcode");
  const zipcodeInput = document.getElementById("cart-zipcode");
  const messageElement = document.getElementById("zipcode-message");

  checkZipcodeButton.addEventListener("click", () => {
    const apiKey = "AIzaSyBRJcUmvzO1o9xd4h6Vw2u0In6HBHPOBd0";
    const zipcode = zipcodeInput.value.trim();

    if (!zipcode) {
      console.log("ZIP Code is missing");
      messageElement.textContent = "Please enter a ZIP code.";
      messageElement.style.color = "red";
      messageElement.style.display = "block";
      return;
    }

    messageElement.textContent = "";
    messageElement.style.display = "none";

    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode}&key=${apiKey}`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);

        if (data.status === "OK" && data.results.length > 0) {
          const location = data.results[0].geometry.location;
          const { lat, lng } = location;
          messageElement.style.color = "green";
          messageElement.style.display = "block";
        } else {
          messageElement.textContent = "Invalid ZIP Code or no data found.";
          messageElement.style.color = "red";
          messageElement.style.display = "block";
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        messageElement.textContent = "An error occurred. Please try again.";
        messageElement.style.color = "red";
        messageElement.style.display = "block";
      });
  });
});

// remove : from line item on cart page
document.querySelectorAll('.drawer__cart-items-wrapper .cart-item dl .product-option dt').forEach(dt => {
  dt.textContent = dt.textContent.replace(':', '');
});

document.addEventListener("DOMContentLoaded", () => {
    let currentMessageElement = null; // Variable to store the currently active message element

    // Check if the product is ONDC
    let isOndcProduct = document.querySelector("form")?.getAttribute("data-is-ondc");
    if (!isOndcProduct) {
        const hiddenInput = document.getElementById('isOndcProduct')?.value;
        if (hiddenInput) {
            isOndcProduct = hiddenInput;
        }
    }

    // Function to remove product from cart based on variant ID
    function removeProductFromCart(variantId) {
        console.log("remove item zipcode change 4");
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const lineItem = cart.items.find(item => item.variant_id == variantId);
                if (lineItem) {
                    fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ id: lineItem.id, quantity: 0 })
                    })
                    .then(response => response.json())
                    .then(updatedCart => {
                        console.log("Product removed from cart:", updatedCart);
                    })
                    .catch(error => {
                        console.error("Error removing product from cart:", error);
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching cart:", error);
            });
    }

    // Add event listener to the "Duplicate" button
    document.querySelectorAll("button[name='duplicate']").forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault(); // Prevent form submission

            // Check if the product is ONDC before proceeding
            if (isOndcProduct !== 'true') {
                console.log("Product is not ONDC, skipping ZIP code check.");
                return; // Skip the ZIP code check if not ONDC
            }

            const productForm = button.closest("form");
            const variantId = productForm.querySelector("input[name='id']").value;
            const alternate_id = productForm.querySelector("input[name='alternate_id']").value;
            const localstorageZipcode = localStorage.getItem("user_postalCode");

            // Retrieve ZIP code, latitude, and longitude from local storage
            const zipcode = localstorageZipcode || "";
            const latitude = localStorage.getItem("user_latitude");
            const longitude = localStorage.getItem("user_longitude");

            const messageElement = productForm.querySelector("#zipcode-message");

            // Hide the previously active message element if there is one
            if (currentMessageElement && currentMessageElement !== messageElement) {
                currentMessageElement.textContent = "";
                currentMessageElement.style.display = "none";
            }

            // Update the current active message element
            currentMessageElement = messageElement;

            // Clear any previous message
            messageElement.textContent = "";
            messageElement.style.display = "none";

            // Ensure ZIP code is provided
            if (!zipcode) {
                messageElement.textContent = "Please enter a ZIP code.";
                messageElement.style.color = "red";
                messageElement.style.fontSize = "14px";
                messageElement.style.display = "block";
                return;
            }

            // Build request body
            const requestBody = {
                store_url: Shopify.shop,
                alternate_id: alternate_id,
                area_code: zipcode,
                latitude: latitude,
                longitude: longitude,
            };

            console.log("Request Body:", requestBody);

            // Make the API request
            fetch("https://live.eazehub.com/live/strsvc/shopify/product-deliverability-status", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            })
            .then((response) => response.json())
            .then((data) => {
                console.log("API Response:", data);
                const deliverableStatus = data.message.data.deliverable;

                const addToCartButton = productForm.querySelector("button[name='add']");
                let message = "";

                if (deliverableStatus === "Yes") {
                    message = "Delivery is available to this ZIP code!";
                    messageElement.style.color = "green";
                    messageElement.style.display = "block";

                    if (addToCartButton) {
                        addToCartButton.disabled = false;
                        addToCartButton.style.display = "block";
                        button.style.display = "none";
                        addToCartButton.click();
                    }
                } else {
                    message = "Sorry, delivery is not available to this ZIP code.";
                    messageElement.style.color = "red";
                    messageElement.style.display = "block";

                    if (addToCartButton) {
                        addToCartButton.disabled = true;
                        addToCartButton.style.pointerEvents = "none";
                    }

                    // Remove product from cart when not deliverable
                    removeProductFromCart(variantId);
                  setTimeout(() => {
                    console.log("remove item zipcode change 5");
                            location.reload();
                        }, 1000);
                  
                }

                messageElement.textContent = message;
            })
            .catch((error) => {
                console.error("Error:", error);
                alert("An error occurred. Please try again.");
            });
        });
    });

    document.querySelectorAll("button[name='add']").forEach((button) => {
        button.addEventListener("click", (event) => {
            if (button.disabled) {
                event.preventDefault();
            }
        });
    });
});

function fetchZipcodeAndCoordinates() {
    // First, get an approximate ZIP code via IP (no popup)
    async function fetchZipFromIP() {
        try {
            const response = await fetch('https://ipapi.co/json/');
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log('IP-Based Location Data:', data);

            const { postal, latitude, longitude } = data;

            if (postal) {
                document.getElementById('cart-zipcode').value = postal;
                document.getElementById('zipcode-span').textContent = `Deliver to: ${postal}`; // Updated format
                localStorage.setItem('user_postalCode', postal);
                localStorage.setItem('user_latitude', latitude);
                localStorage.setItem('user_longitude', longitude);

                console.log(`Updated Postal Code from IP: ${postal}`);
                console.log(`Latitude from IP: ${latitude}, Longitude from IP: ${longitude}`);
            } else {
                console.error("Postal code not found in IP-based location data.");
            }
        } catch (error) {
            console.error("Error fetching ZIP from IP:", error.message);
        }
    }

    // Second, request precise GPS location (shows popup)
    function fetchZipFromGPS() {
        if (navigator.geolocation) {
            console.log('Requesting precise location...');

            navigator.geolocation.getCurrentPosition(
                async function (position) {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;

                    console.log('GPS Latitude:', latitude);
                    console.log('GPS Longitude:', longitude);

                    // Reverse Geocoding using Google Maps API to get ZIP only
                    const apiKey = 'AIzaSyBRJcUmvzO1o9xd4h6Vw2u0In6HBHPOBd0'; // Using the same API key
                    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

                    try {
                        const response = await fetch(url);
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }

                        const data = await response.json();
                        console.log('Geocoding API Response:', data);

                        if (data.status === "OK") {
                            let postalCode = '';
                            data.results[0].address_components.forEach(component => {
                                if (component.types.includes('postal_code')) {
                                    postalCode = component.long_name;
                                }
                            });

                            console.log(`Updated Postal Code from GPS: ${postalCode}`);

                            if (postalCode) {
                                document.getElementById('cart-zipcode').value = postalCode;
                                document.getElementById('zipcode-span').textContent = `Deliver to: ${postalCode}`; // Updated format
                                localStorage.setItem('user_postalCode', postalCode);
                            }

                            // Store latitude & longitude
                            localStorage.setItem('user_latitude', latitude);
                            localStorage.setItem('user_longitude', longitude);
                        } else {
                            console.error("Geocoding API Error:", data.status, data.error_message);
                        }
                    } catch (error) {
                        console.error("Error fetching ZIP from GPS:", error.message);
                    }
                },
                function (error) {
                    console.error("GPS Geolocation error:", error.message);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }

    // First, fetch ZIP from IP without permission popup
    fetchZipFromIP().then(() => {
        // Then request GPS location
        fetchZipFromGPS();
    });
}

// Attach the function to the button
document.getElementById('set-zipcode').addEventListener('click', fetchZipcodeAndCoordinates);

